import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationDirection, PaginationModel} from "../../common/models/pagination.model";

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  @Output() paginate = new EventEmitter<PaginationModel>();
  @Input() pagination: PaginationModel;
  constructor() { }

  ngOnInit(): void {
  }

  goToPrev(pagination: PaginationModel): void{
    pagination.urlBaseOverride = pagination.previous;
    pagination.paginationDirection = PaginationDirection.previous;
    this.paginate.emit(pagination);
  }

  goToNext(pagination: PaginationModel): void{
    pagination.urlBaseOverride = pagination.next;
    pagination.paginationDirection = PaginationDirection.next;
    this.paginate.emit(pagination);
  }



}
